import { render, staticRenderFns } from "./wizardTrainerRegistration.vue?vue&type=template&id=1085b03c&scoped=true"
import script from "./wizardTrainerRegistration.vue?vue&type=script&lang=js"
export * from "./wizardTrainerRegistration.vue?vue&type=script&lang=js"
import style0 from "./wizardTrainerRegistration.vue?vue&type=style&index=0&id=1085b03c&prod&scoped=true&lang=css"
import style1 from "./wizardTrainerRegistration.vue?vue&type=style&index=1&id=1085b03c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1085b03c",
  null
  
)

export default component.exports